import { defineStore } from "pinia";
import GlobalUtil from "../../utils/pricetravel/shared/globalUtil";
import { SearchHistory } from "../../utils/pricetravel/shared/searchHistory";
import BookerTracker from "../../MetricsTracker/booker/metrics";

const fn = window.__pt.fn;
const config = window.__pt.settings.site;
const setting = window.__pt.settings;

const _globalUtil = new GlobalUtil();
const _userKey = _globalUtil.getUserKey();
const _tracker = new BookerTracker();
const defaultDate = fn.getDate();

const __ = (str, values = []) => {
  const _ = window._;
  let formatted = _.get(window.i18n, str, str);

  if (values.length) {
    formatted = _.replace(formatted, /\{\d\}/g, (match) => {
      const index = match.replace(/\{|\}/g, "");
      return values[index] || match;
    });
  }

  return formatted;
};

export const useFlightBookerStore = defineStore("flightBooker", {
  state: () => ({
    form: {
      from: "",
      to: "",
      dates: "",
      guests: "",
      type: true,
    },
    fieldErrors: {
      to: "",
      from: "",
      dates: "",
      guests: "",
    },
    book: setting.defaultFlight,
    recentSearches: {
      from: [],
      to: [],
    },
    popularDestinations: {
      from: [],
      to: [],
    },
    searchResults: {
      from: [],
      to: [],
    },
    algoliaUrl: "https://img.cdnpth.com/media/assets/recent-search-imgs/iatas/",
    OpenSearch: {
      from: false,
      to: false,
    },
    CloseSearch: {
      from: false,
      to: false,
    },
    lastQuery: "",
    configDaysPrequote: {
      weeksPrequote: 0,
      daysPrequote: 0,
      startDate: 0,
    },
    localeDatePicker: {
      format: setting.formatBoxDate,
      firstDay: 0,
    },
    settingPaxes: {
      minAdults: 1,
      maxAdults: 9,
      minChildren: 0,
      maxChildren: 8,
      minAge: 1,
      maxAge: 11,
      totalPaxes: 9,
    },
  }),
  getters: {
    isFormValid(state) {
      return (
        state.form.from &&
        state.form.from.trim() !== "" &&
        state.form.to &&
        state.form.to.trim() !== "" &&
        state.form.dates &&
        state.form.dates.trim() !== "" &&
        state.form.guests &&
        state.form.guests.trim() !== ""
      );
    },
    totalAdults(state) {
      return state.book.paxes.reduce((acc, room) => acc + (room.adults || 0), 0) || 1;
    },
    totalChildren(state) {
      return state.book.paxes.reduce((acc, room) => acc + (room.children?.length || 0), 0);
    },
    paxSummary(state) {
      const adults = state.totalAdults;
      const children = state.totalChildren;
      const adultsTitle = (adults === 1 ? __('booker.adult') : __('booker.adults')).toLowerCase();
      const childrenTitle = (children === 1 ? __('booker.children') : __('booker.childrens')).toLowerCase();
      let childrenText = children > 0 ? `, ${children} ${childrenTitle}` : "";
      return `${adults} ${adultsTitle}${childrenText}`;
    },
  },
  actions: {
    validateForm(omitField = false) {
      this.clearFieldErrors();
      let valid = true;

      if (!this.book.place_name || !this.form.from || this.form.from.trim() === "") {
        if (!omitField) {
          this.setFieldError("from", __("booker.select_origin"));
        }
        valid = false;
      }
      if (!this.form.to || this.form.to.trim() === "") {
        if (!omitField) {
          this.setFieldError("to", __("booker.select_destination"));
        }
        valid = false;
      }
      if (!this.form.dates || this.form.dates.trim() === "") {
        if (!omitField) {
          this.setFieldError("dates", __("booker.select_dates"));
        }
        valid = false;
      }
      if (!this.form.guests || this.form.guests.trim() === "") {
        if (!omitField) {
          this.setFieldError("guests", __("booker.select_guests"));
        }
        valid = false;
      }
      if (this.form.from && this.form.to && this.book.place_selected.code == this.book.place_selected_to.code) {
        if (!omitField) {
          this.setFieldError("to", __("booker.select_different_destination"));
        }
        valid = false;
      }

      if (this.validAgeChildrenforAdult()) {
        if (!omitField) {
          this.setFieldError("guests", __("booker.notificationKids"));
        }
        valid = false;
      }



      return valid;
    },
    getAnalyticsTags() {
      var arrTags = [];
      if (fn.mobileAndTabletCheck()) {
        arrTags.push("web_mobile");
      } else {
        arrTags.push("web_desktop");
      }
      var pathName = _globalUtil.getFirstPathSegment();
      if (pathName == "hotel") {
        arrTags.push("detail");
      } else if (pathName == "hoteles" || pathName == "hotels") {
        arrTags.push("list");
      } else if (setting.page == "landings") {
        arrTags.push("landings");
      } else {
        arrTags.push("home");
      }
      return arrTags.join(",");
    },
    async fetchSearchResults(value, mobile, list) {
      if (!value || (value && value.length < 3)) {
        this.searchResults[list] = [];
        if (!mobile) {
          this.OpenSearch[list] = false;
        }
        return;
      }
      const params = {
        query: value,
        language: config.language,
        placeTypes: config.placesTypeHotel,
        from: 0,
        size: config.siteName == "tiquetesbaratos" ? 5 : 10,
        usersearch: _userKey,
        site: config.code,
        version: "v2",
        analyticsTags: this.getAnalyticsTags(),
      };
      let response = await axios
        .get(config.endPoints.suggestionFlightUrl, { params })
        .catch((data) => console.log(data));
      if (response && response.status == 200) {
        const data = response.data || [];
        if (data.length > 0) {
          this.lastQuery = params.query;
          _tracker.metricAutocompleteFlight(params.query, response.data, list);
        }
        this.searchResults[list] = data;
        if (!mobile) {
          this.OpenSearch[list] = false;
          setTimeout(() => {
            this.OpenSearch[list] = true;
          }, 10);
        }
      }
    },
    async fetchPopularDestinations(element, origin) {
      if (this.popularDestinations[element].length > 0) {
        return;
      }
      const params = {
        analyticsTags: this.getAnalyticsTags(),
        from: 0,
        language: config.language,
        placeTypes: 0,
        site: config.code,
        size: 5,
        usersearch: _userKey,
        recommendation: true,
        origin: element == "to" ? origin : null,
      };
      let response = await axios
        .get(config.endPoints.suggestionFlightUrl, { params })
        .catch((data) => console.log(data));
      if (response && response.status == 200) {
        const data = response.data || [];
        this.popularDestinations[element] = data;
      }
    },
    loadSearchHistory() {
      const history = SearchHistory.getFlight("F");
      this.recentSearches = history;
      ["from", "to"].forEach((key) => {
        this.recentSearches[key]?.forEach((item) => {
          item.displayDestinationHtml = this.stripHtml(
            item.displayDestinationHtml,
          );
          item.code = this.stripHtml(item.code);
        });
      });
    },
    stripHtml(html) {
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    updateInputPaxes() {
      const summary = this.paxSummary;
      this.book.paxes_name = summary;
      this.book.paxes_people = this.totalAdults + this.totalChildren;
      this.book.capacityTotal = this.book.paxes_people;
      this.form.guests = summary;
    },
    getInitialDate(date = fn.getDate(), value = config.bookerDefaultCheckInDay) {
      let dateNew = fn.getDate(fn.formatDate(date, setting.formatDate));
      dateNew.setDate(dateNew.getDate() + value);
      return dateNew;
    },
    initialDefaultDate() {
      this.book.checkIn = this.getInitialDate(defaultDate);
      this.book.checkOut = this.getInitialDate(
        defaultDate,
        config.bookerDefaultCheckInDay + config.bookerDefaultCheckOutDay,
      );
    },
    getUserSelectionParams() {
      let params = fn.search();
      let data = {};
      let _placeOrigin = window.__pt.placeOrigin || {};
      let _placeDestination = window.__pt.placeDestination || {};

      data.place_name = _placeOrigin.DisplayText || "";
      data.place_name_to = _placeDestination.DisplayText || "";

      data.place_selected = _placeOrigin;
      data.place_selected_to = _placeDestination;

      data.checkIn = params.startingFromDateTime || this.book.checkIn;
      data.checkOut = params.returningFromDateTime || this.book.checkOut;
      data.mode = params.tripMode ? params.mode === "1" : this.book.mode;

      let pax = {
        adults: +(params[`adults`] || 1),
        children: []
      }

      let children = params[`agekids`];
      if (children) {
        let childrenSplit = children.split(",");

        for (var c = 0; c < childrenSplit.length; c++) {
          pax.children.push({
            year: +(childrenSplit[c]) || 0
          })
        }
      }

      data.paxes = [pax];
      return data;
    },
    initSearchBox() {
      let paramsData, storageData;

      if (setting.page != 'home') {
        paramsData = this.getUserSelectionParams();
      } else {
        storageData = SearchHistory.getFirstEntry("F");
      }

      this.book = paramsData || storageData || this.book;
      this.fillHistory();
      if (paramsData || storageData) {
        this.book.checkIn = fn.getDate(this.book.checkIn);
        this.book.checkOut = fn.getDate(this.book.checkOut);

        if ((+this.book.checkIn <= +defaultDate)) {
          this.initialDefaultDate();
        }
      }
      this.updateInputPaxes();
    },
    fillHistory() {
      this.form.from = this.book.place_name;
      this.form.to = this.book.place_name_to;
      this.form.mode = this.book.mode;

    },
    selectDestination(item, type, suffix = "") {
      const displayName = `${item.place_selected.displayText} - ${this.stripHtml(item.place_selected.displayDestinationHtml)} (${item.place_selected.code})`;
      this.book[`place_name${suffix}`] = displayName;
      this.book[`place_selected${suffix}`] = item.place_selected;
      this.form[type] = displayName;
      this.CloseSearch[type] = true;
      this.OpenSearch[type] = true;
      setTimeout(() => {
        this.OpenSearch[type] = false;
      }, 10);
      return item.place_selected.code; // Used for origin in popular destinations
    },
    validAgeChildrenforAdult() {
      let paxesKeys = {};
      let adults = 0;
      let kids = 0;
      let agekids = [];
      let rooms = this.book.paxes.length;

      for (let i = 0; i < rooms; i++) {
        const room = this.book.paxes[i];

        adults += room.adults;

        let childrens = room.children.length;
        let childreJoin = [];
        for (let c = 0; c < childrens; c++) {
          const childrenRoom = room.children[c];
          childreJoin.push(childrenRoom.year);
          agekids.push(childrenRoom.year);
          kids += 1;
        }

      }
      paxesKeys[`adults`] = adults;
      paxesKeys[`kids`] = kids;
      paxesKeys[`agekids`] = agekids.join(",");


      let totalChildren = 0;
      if (paxesKeys[`adults`] < paxesKeys[`kids`]) {

        agekids.forEach((age, index) => {
          if (age == 1)
            totalChildren++;
        });

        if (totalChildren > paxesKeys[`adults`]) {
          return true;
        }
        else return false;
      }
      else return false;

    },
    submitSearch() {

      if (!this.validateForm()) {
        return;
      }

      const airlinePathURL = window.location.pathname.split("/").filter(Boolean);
      const airlineKeywords = ["aerolineas", "airlines"];
      let landing = "";
      const index = airlinePathURL.findIndex((segment) =>
        airlineKeywords.includes(segment),
      );
      if (index !== -1 && airlinePathURL[index + 1])
        landing = airlinePathURL[index + 1];
      let paxesData = SearchHistory.mapFlightPaxQuery(this.book.paxes);
      let mode = this.form.type ? "1" : "0";

      let data = {
        startingFromAirport: this.book.place_selected.code,
        returningFromAirport: this.book.place_selected_to.code,
        startingFromDateTime: fn.formatDate(this.book.checkIn, setting.formatDate),
        returningFromDateTime: fn.formatDate(
          this.book.checkOut,
          setting.formatDate,
        ),
        tripMode: mode,
        mode: mode,
        originName: this.book.place_name,
        destinationName: this.book.place_name_to,
      };
      if (landing !== "") data.addfirst = landing;
      data = { ...data, ...paxesData };

      var path = config.pathFlight;
      _tracker.metricBookerFlight("booker", { vmData: this.book, data });



      // ---- FORM de VUELOS ----
      var formFlight = document.createElement("form");
      formFlight.setAttribute("method", "get");
      formFlight.setAttribute("action", `${path}`);
      for (var key in data) {
        if (data[key] !== undefined && data[key] !== null && String(data[key]) !== "") {
          var hiddenField = document.createElement("input");
          hiddenField.setAttribute("type", "hidden");
          hiddenField.setAttribute("name", key);
          hiddenField.setAttribute("value", String(data[key]));
          formFlight.appendChild(hiddenField);
        }
      }

      SearchHistory.set(this.book, "F");
      if ($("#loader-page").length > 0) {
        $("#loader-page").removeClass("d-none");
      }

      if (config.activeTab && !config.mobile && this.form.type) {
        (function openFlightsInNewTab() {
          const flightQS = new URLSearchParams(data).toString();
          const flightURL = `${path}?${flightQS}`;
          window.open(flightURL, '_blank');
        })();
        this.resolvePackagesThenGoHotelsHereWithDelay();
      } else {
        document.body.appendChild(formFlight);
        formFlight.submit();
        return;

      }
    },
    setFieldError(key, value) {
      this.fieldErrors[key] = value;
    },
    clearFieldErrors() {
      this.fieldErrors.from = "";
      this.fieldErrors.to = "";
      this.fieldErrors.dates = "";
      this.fieldErrors.guests = "";
    },
    resolvePackagesThenGoHotelsHereWithDelay() {
      // delay 
      setTimeout(() => {
        const params = {
          query: this.book.place_name_to,
          language: config.culture,
          placeTypes: config.placesTypePackages,
          from: 0,
          size: 1,
          site: config.code,
          destination: 1
        };
        axios.get(config.endPoints.suggestionPackageUrl, { params })
          .then((res) => {
            const first = (res && res.data && res.data[0]) || null;
            const seoCode = String(first.placeCode ?? first.code).toLowerCase();
            const seoId = (first.placeId ?? first.id);

            // url final de hoteles 
            const hotelBase = "/" + config.culture + "/" + __pt.culture.pathHotelList + seoCode + "_d" + seoId;
            const hotelParams = {
              adults: "1",
              checkin: fn.formatDate(this.book.checkIn, setting.formatDate),
              checkout: fn.formatDate(this.book.checkOut, setting.formatDate),
              group_adults: "1",
              no_rooms: "1"
            };
            const paramsQuery = fn.search();
            if (paramsQuery.CampaignToken) {
              hotelParams.CampaignToken = paramsQuery.CampaignToken;
            }
            hotelParams.ref = "flights";

            const fullUrl = hotelBase + "?" + new URLSearchParams(hotelParams).toString();

            window.location.assign(fullUrl); // hoteles en esta pestaña
          })
          .catch((err) => {
          });
      }, 3000);
    }
  },
});
